export default __webpack_public_path__ + "static/media/high-icon-1.3f693e99.png";